module.exports = __webpack_public_path__ + "assets/stand22.1d8fb4c0ac6727dfc170bd94b4201b8f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/stand22.png
 ** module id = 195
 ** module chunks = 0
 **/